"use client";

import { useEffect } from "react";
import { trackHelpScoutOpen, trackHelpScoutMessageSent } from "@/lib/analytics";

declare global {
  interface Window {
    Beacon?: (action: string, ...args: any[]) => void;
  }
}

export function HelpScoutBeaconTracker() {
  useEffect(() => {
    // Wait for HelpScout Beacon to be available
    const checkBeacon = () => {
      if (typeof window !== "undefined" && window.Beacon) {
        // Track when beacon is opened
        window.Beacon("on", "open", () => {
          trackHelpScoutOpen();
        });

        // Track when user sends a message
        window.Beacon("on", "message-sent", () => {
          trackHelpScoutMessageSent();
        });

        // Track when user starts typing (engagement)
        window.Beacon("on", "contact-form-shown", () => {
          // User opened the contact form - high engagement signal
          trackHelpScoutOpen();
        });

        return true;
      }
      return false;
    };

    // Try to initialize immediately
    if (!checkBeacon()) {
      // If not available, wait and try again
      const interval = setInterval(() => {
        if (checkBeacon()) {
          clearInterval(interval);
        }
      }, 1000);

      // Clean up interval after 10 seconds
      setTimeout(() => {
        clearInterval(interval);
      }, 10000);

      return () => clearInterval(interval);
    }
  }, []);

  return null; // This component doesn't render anything
}
